import { useQuery } from "@tanstack/react-query";
import { clientBrandingApi } from "../api";
import { qk } from "../../lib/queryKeys";

export const useClientBranding = (clientId?: string | null) => {
  return useQuery({
    queryKey: qk.clientBranding(clientId),
    queryFn: () => clientBrandingApi.getClientBranding(clientId as string),
    enabled: !!clientId,
    staleTime: 10 * 60 * 1000,
  });
};
